import { get } from "lodash";

import { Attempt } from "../../lib/reports";
import { useReport } from "./ReportProvider";

// Returns a function that records the affected document upload for a report.
export const useCaptureDocumentAttempt = (
  integration: string | undefined,
  loginInformation: unknown
) => {
  const reporting = useReport();
  return (attempt?: Pick<Attempt, "documentRef" | "documentClassification">) =>
    reporting?.captureAttempt("document-upload", {
      integration,
      carrierId: get(loginInformation, "carrier.id"),
      ...attempt,
    });
};
